import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";

const CustomDatePicker = ({
  value,
  onChange,
  placeholderText = "MM/dd/yyyy",
  dateFormat = "MM/dd/yyyy",
  maxDate = new Date(),
  isReadOnly = false,
  className = "",
  renderCustomHeader,
}) => {
  const handleDateChange = (date) => {
    if (date) {
      const formattedDate = format(date, dateFormat);
      onChange(formattedDate);
    } else {
      onChange(null);
    }
  };

  const defaultRenderCustomHeader = ({
    date,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
  }) => {
    const selectedDate =
      date instanceof Date && !isNaN(date) ? date : new Date();
    const selectedMonth = selectedDate.getMonth();
    const selectedYear = selectedDate.getFullYear();

    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "8px", padding: "8px 4px" }}>
        <button
          onClick={decreaseMonth}
          disabled={prevMonthButtonDisabled}
          style={{ padding: "4px 8px", cursor: "pointer" }}
        >
          {"<"}
        </button>
        <div style={{ display: "flex", gap: "8px", flex: 1, alignItems: "center" }}>
          <select
            value={selectedMonth}
            onChange={({ target: { value } }) =>
              changeMonth(Number(value))
            }
            style={{ padding: "4px 8px", cursor: "pointer", flex: 1 }}
          >
            {Array.from({ length: 12 }, (_, i) => (
              <option key={i} value={i}>
                {new Date(0, i).toLocaleString("default", { month: "long" })}
              </option>
            ))}
          </select>
          <select
            value={selectedYear}
            onChange={({ target: { value } }) =>
              changeYear(Number(value))
            }
            style={{ padding: "4px 8px", cursor: "pointer", flex: 1 }}
          >
            {Array.from({ length: 100 }, (_, i) => (
              <option key={i} value={new Date().getFullYear() - i}>
                {new Date().getFullYear() - i}
              </option>
            ))}
          </select>
        </div>
        <button
          onClick={increaseMonth}
          disabled={nextMonthButtonDisabled}
          style={{ padding: "4px 8px", cursor: "pointer" }}
        >
          {">"}
        </button>
      </div>
    );
  };

  return (
    <DatePicker
      value={value}
      onChange={handleDateChange}
      dateFormat={dateFormat}
      maxDate={maxDate}
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      readOnly={isReadOnly}
      className={className}
      placeholderText={placeholderText}
      renderCustomHeader={renderCustomHeader || defaultRenderCustomHeader}
    />
  );
};

export default CustomDatePicker;
